import { Icon, Icons } from '@silverfort/sf-components';
import React from 'react';

const Badge = (props) => {
    const calcBadgeColors = () => {
        if (props.selected) {
            return 'bg-sf-primary text-white';
        }

        return props.darkMode ? 'bg-transparent text-stone-300' : 'bg-white text-sf-primary';
    };

    return props.newDesign ? (
        <div
            className={`flex w-max center border rounded-lg h-8 mr-2 px-3 text-13 cursor-pointer  ${
                props.selected ? 'border-sf-primary-500 text-sf-primary-500' : 'border-sf-gray-100 text-sf-gray-800'
            }`}>
            <button onClick={props.clicked}>
                <span style={{ width: props.width }} className="p-0.5 font-normal">{`${props.header} ${
                    props.description ? ':' : ''
                }`}</span>
                {props.description && <span className="mx-1 font-medium">{props.description}</span>}
            </button>
            {props.hasClear && (
                <button className={`w-fit px-0.5`} onClick={props.cleared}>
                    <Icon icon={Icons.Cancel} />
                </button>
            )}
        </div>
    ) : (
        <div
            className={`flex w-max center border-solid border border-sf-primary rounded-3xl h-6 mb-0.5 mx-1 pb-0.5 px-1.5 text-sm cursor-pointer ${calcBadgeColors()}`}>
            <button onClick={props.clicked}>
                <span style={{ width: props.width }} className="p-0.5 font-semibold">{`${props.header} ${
                    props.description ? ':' : ''
                }`}</span>
                {props.description && <span className="mx-1">{props.description}</span>}
            </button>
            {props.hasClear && (
                <button className={`font-extralight w-fit px-0.5`} onClick={props.cleared}>
                    <i className="fa fa-times"></i>
                </button>
            )}
        </div>
    );
};

export default Badge;
